export const AlertMessages = {
  slGlJournalExists: 'Selected row cannot be deleted because the Tax Entry is used in an existing Balance Sheet Management GL Journal definition for this period.',
};

export const yesNoFlagOptions = [
  {
    label: 'Yes',
    value: 'Y',
  },
  {
    label: 'No',
    value: 'N',
  },
];

export const yesNoAlwaysFlagOptions = [
  ...yesNoFlagOptions,
  {
    label: 'Always',
    value: 'A',
  },
];

export const ADMIN_TAX_ENTRY_INDEX_KEY = ['type', 'activity'];
export const ADMIN_TAX_ENTRY_SORT_KEY = ['type'];
